import React from "react";
import TypographyCompo from "../../../components/Comman/TypographyCompo";
import { styles } from "../styles/ProductLevelChallanData";
import { greenShadeColor, orangeFade, redStrongColor } from "../../../config/ColorObj";

const SellProgressBar = ({ sellQty, challanQty }) => {
    const pct = challanQty ? Math.round((sellQty / challanQty) * 100) : 0;

    const fillColor =
        pct >= 70 ? greenShadeColor :
            pct >= 40 ? orangeFade :
                redStrongColor;

    return (
        <div style={styles.progressWrap}>
            <div style={styles.progressTrack}>
                <div
                    style={{
                        ...styles.progressFill,
                        width: `${pct}%`,
                        background: fillColor,
                    }}
                />
            </div>
            <TypographyCompo style={styles.progressPct}>
                {pct}%
            </TypographyCompo>
        </div>
    );
};

export default React.memo(SellProgressBar);
